import BaseMiddleware from "src/middleware/BaseMiddleware";
import {types as authType} from "src/store/modules/Auth.module";
import store from "src/store";

class CheckMiddleware extends BaseMiddleware {

	async handle(next, to, from) {
		if (!store.getters.isConnected) {
			try {
				await store.dispatch(authType.GET);
				return next();

			} catch (e) {
				return next();
			}
		} else {
			return next();
		}
	}
}



export default CheckMiddleware;
